export enum FieldTypesEnum {
    MultiSelect = 'MultiSelect',
    JustText = 'JustText',
    Select = 'Dropdown',
    Radio = 'Radio',
    Text = 'Text',
    Date = 'Date'
}

export enum DraggableTypesEnum {
    Subject = 'SUBJECT',
    Clause = 'CLAUSE',
    Field = 'FIELD',
    Block = 'BLOCK'
}
